import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.css';

import {useDispatch, useSelector} from 'react-redux';
import {useEffect, useContext, useState} from 'react';
import {getRestaurantThunk} from './store/restaurant';
import Context from './Context';
import {Route, Routes, useLocation} from 'react-router-dom';
import OnlineOrder from './Pages/OnlineOrder';
import CheckoutPage from './Pages/Checkout';
import ScrollToTop from './elements/ScrollToTop';
import OrderConfirmed from './Pages/OrderPlaced';
import Header from './elements/Header';
import Home from './Pages/Home';
import Receipt from './Pages/Receipt';
import Menu from './Pages/menu';
import Menu2 from './Pages/menu2';
import ContactUs from './Pages/Contact';
// kuru相关
import KuruHome from './Pages/KuruHome'
import Navbar from "@/kuruComponents/Navbar";
import Footer from "@/kuruComponents/Footer";
function App() {
    const dispatch = useDispatch();
    const restaurant = useSelector(state => state.restaurants.restaurant);
    const {restaurantId} = useContext(Context);

    useEffect(() => {
        if (restaurantId) {
            dispatch(getRestaurantThunk(restaurantId));
        }
    }, [dispatch, restaurantId]);


    return (
        <div className="App">
            {/*<Header/>*/}
            <Navbar />
            <ScrollToTop/>
            <Routes>
                <Route exact path='/' element={<KuruHome restaurant={restaurant}/>}/>
                <Route exact path='/hongkongHome' element={<Home restaurant={restaurant}/>}/>
                <Route path="/order" element={<OnlineOrder restaurant={restaurant}/>}/>
                <Route path='/checkout' element={<CheckoutPage fee={restaurant?.Restaurant_Fees[0]}/>}/>
                <Route path='/orderconfirmed' element={<OrderConfirmed/>}/>
                <Route path='/order/:id/:restaurant_id' element={<Receipt/>}/>
                <Route path='/menu' element={<Menu restaurant={restaurant}/>}/>
                <Route path='/menu2' element={<Menu2 restaurant={restaurant}/>}/>
                <Route path='/contact' element={<ContactUs/>}/>
            </Routes>
        </div>
    );
}

export default App;
